import React, { useEffect, useState } from "react";
import NavbarWrapper from "../../../widgets/navbarWrapper";
import ScheduleCalendar from "./calendarSchedule";
import Spinner from "../loading/spinner";
import defaultProfile from "../../../assets/user.jpg";

const Dashboard = () => {
  const [state, setState] = useState({
    loadingSpinner: false,
    doctorData: {
      firstName: "Dr.",
      lastName: "",
      imageUpload: null,
    },
    profileImage: defaultProfile,
  });

  const getUserData = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user")) || {};
      return user;
    } catch {
      return {};
    }
  };

  useEffect(() => {
    const user = getUserData();
    setState((prev) => ({
      ...prev,
      doctorData: {
        firstName: user.firstName || "Dr.",
        lastName: user.lastName || "",
        imageUpload: user.imageUpload || null,
      },
      profileImage: user.imageUpload || defaultProfile,
      loadingSpinner: false,
    }));
  }, []);

  return (
    <>
      <NavbarWrapper showNavbar={true} />
      <main className="h-[calc(99vh-64px)] overflow-hidden bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 flex flex-col">
          <div className="flex-1 min-h-0 bg-white rounded-2xl shadow-lg p-4 sm:p-6 border border-gray-100/80 overflow-hidden">
            <ScheduleCalendar />
          </div>
        </div>
      </main>
      {state.loadingSpinner && <Spinner />}
    </>
  );
};

export default Dashboard;